(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', function (e) {
    if (!e.target.classList.contains('filter-disclosure') && !e.target.classList.contains('sort-disclosure')) return;

    if (e.target.open) {
      document.body.setAttribute('data-scroll-locked', '');
    } else {
      // Unlock scroll only if no other filter is still open
      if (!document.querySelector('.filter-disclosure[open], .sort-disclosure[open]')) {
        document.body.removeAttribute('data-scroll-locked');
      }
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
